import M from "materialize-css";
export default {
  install(Vue) {
    Vue.prototype.$messageAlert = function (html) {
      M.toast({ html, classes: "alert" });
    };
    Vue.prototype.$message = function (html) {
      M.toast({ html, classes: "alert" });
    };
    Vue.prototype.$error = function (html) {
      M.toast({ html: html, classes: "error" });
    };
  },
};
